import { Controller } from '@hotwired/stimulus'

/**
 * @description Stimulus controller to live update an image with an uploaded file
 */
export default class ImagePreviewController extends Controller {
  static targets = ['imageUpload', 'imageDestination']
  static values = { defaultPreview: String }

  connect() {
    if (this.hasDefaultPreviewValue) {
      this.imageDestinationTarget.onerror = () => {
        this.imageDestinationTarget.src = this.defaultPreviewValue
      }
    }
  }

  disconnect() {
    this.revokePreviewUrl()
  }

  show() {
    const uploadedFile = this.imageUploadTarget.files[0]
    if (uploadedFile.type.startsWith('image/')) {
      this.revokePreviewUrl()
      this.previewUrl = URL.createObjectURL(uploadedFile)
      this.imageDestinationTarget.src = this.previewUrl
    }
  }

  revokePreviewUrl() {
    if (!this.previewUrl) return

    URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = null
  }
}
